import { render } from "./layout2.vue?vue&type=template&id=4da6f056&scoped=true"
import script from "./layout2.vue?vue&type=script&lang=js"
export * from "./layout2.vue?vue&type=script&lang=js"

import "./layout2.vue?vue&type=style&index=0&id=4da6f056&scoped=true&lang=css"
import "./layout2.vue?vue&type=style&index=1&id=4da6f056&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da6f056"]])

export default __exports__